import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const PlusIcon = (props: SvgIconProps) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path d="M9 15.1094C9 15.6617 9.44772 16.1094 10 16.1094C10.5523 16.1094 11 15.6617 11 15.1094V11.1094H15C15.5523 11.1094 16 10.6617 16 10.1094C16 9.55709 15.5523 9.10938 15 9.10938H11V5.10938C11 4.55709 10.5523 4.10938 10 4.10938C9.44772 4.10938 9 4.55709 9 5.10937V9.10938H5C4.44772 9.10938 4 9.55709 4 10.1094C4 10.6617 4.44772 11.1094 5 11.1094H9V15.1094Z" />
  </SvgIcon>
);

export default PlusIcon;
